import { QuizzesRequire, QuizzesRequireHrLockAt } from '@/models/Quiz';

export class Quizzes implements QuizzesRequireHrLockAt, QuizzesRequire {
  requireOsh: boolean = false;
  requireKnf: boolean = false;
  requireStmt: boolean = false;
  requireEthic: boolean = false;
  requireKnfHrLockAt?: Date;
  requireStmtHrLockAt?: Date;
  requireEthicHrLockAt?: Date;
  requireBankStmtHrLockAt?: Date;
  requireBankStmt: boolean = false;
}
export class QuizzesToSend {
  requireOshQuiz: boolean = false;
  requireKnfQuiz: boolean = false;
  requireStmtQuiz: boolean = false;
  requireEthicQuiz: boolean = false;
  requireBankStmtQuiz: boolean = false;
}
